import { FC } from 'react';

import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

import { If } from '@hsp/react-component-library';

import { usePaginationItems } from 'components/table/components/paginator/hooks';
import { useTableStoreSelector } from 'components/table/hooks/context';
import { PagesProps } from 'types/components/table/components/paginator';

const Pages: FC<PagesProps> = ({ maxPageButtons = 5, onPageChanged, showFirstLastButtons = true }) => {
  const hasNextPage = useTableStoreSelector((state) => state.hasNextPage);
  const hasPreviousPage = useTableStoreSelector((state) => state.hasPreviousPage);
  const numberOfPages = useTableStoreSelector((state) => state.numberOfPages);
  const page = useTableStoreSelector((state) => state.page);
  const pageSize = useTableStoreSelector((state) => state.pageSize);
  const total = useTableStoreSelector((state) => state.total);

  const paginationItems = usePaginationItems(total, maxPageButtons, page, pageSize);

  return (
    <Pagination
      className="ms-3"
      size="sm">
      <If condition={showFirstLastButtons}>
        <PaginationItem
          disabled={!hasPreviousPage}
          onClick={(e) => {
            if (!hasPreviousPage) {
              e.preventDefault();

              return;
            }
            onPageChanged?.(1);
          }}>
          <PaginationLink
            first
            type="button"
          />
        </PaginationItem>
      </If>
      <PaginationItem
        disabled={!hasPreviousPage}
        onClick={(e) => {
          if (!hasPreviousPage) {
            e.preventDefault();

            return;
          }
          onPageChanged?.(page - 1);
        }}>
        <PaginationLink
          previous
          type="button"
        />
      </PaginationItem>
      {paginationItems.map((currentPage) => (
        <PaginationItem
          active={page === currentPage}
          key={currentPage}
          onClick={() => onPageChanged?.(currentPage)}>
          <PaginationLink type="button">{currentPage}</PaginationLink>
        </PaginationItem>
      ))}
      <PaginationItem
        disabled={!hasNextPage}
        onClick={(e) => {
          if (!hasNextPage) {
            e.preventDefault();

            return;
          }
          onPageChanged?.(page + 1);
        }}>
        <PaginationLink
          next
          type="button"
        />
      </PaginationItem>
      <If condition={showFirstLastButtons}>
        <PaginationItem
          disabled={!hasNextPage}
          onClick={(e) => {
            if (!hasNextPage) {
              e.preventDefault();

              return;
            }
            onPageChanged?.(numberOfPages);
          }}>
          <PaginationLink
            last
            type="button"
          />
        </PaginationItem>
      </If>
    </Pagination>
  );
};

export default Pages;
